export default "__VITE_ASSET__CwbJ9Ba9__"